<ng-container *ngIf="this.dsAlert && this.dsAlert.length > 0">
  <ng-container  *ngFor="let alert of this.dsAlert">
    <ng-container *ngTemplateOutlet="default; context: { alert: alert }"></ng-container>
  </ng-container>
</ng-container>

<ng-template #default let-alert="alert">
  <div
      class="alert alert-danger alert-dismissible fade show"
      [class.alert-danger]="alert.status=='danger'"
      [class.alert-success]="alert.status=='success'"
      role="alert">
      {{alert.description}}
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    </div>
</ng-template>
